document.addEventListener('DOMContentLoaded', function() {
    function handleParallax() {
        const parallax1 = document.getElementById('news-1-parallax-1');
        const parallax2 = document.getElementById('news-1-parallax-2');

        if (!parallax1 || !parallax2) return;

        const scrollY = window.scrollY;
        const windowHeight = window.innerHeight;

        // Handle Parallax Image 1
        const parallaxImage1 = parallax1.querySelector('img');
        const image1Rect = parallax1.getBoundingClientRect();

        if (image1Rect.top < windowHeight && image1Rect.bottom > 0) {
            const offset1 = Math.max(0, (scrollY - image1Rect.top) * 0.4);
            parallaxImage1.style.transform = `translateY(${offset1}px)`;
        } else {
            parallaxImage1.style.transform = 'translateY(0)';
        }

        // Handle Parallax Image 2
        const parallaxImage2 = parallax2.querySelector('img');
        const image2Rect = parallax2.getBoundingClientRect();

        if (image2Rect.top < windowHeight && image2Rect.bottom > 0) {
            const offset2 = Math.max(0, (scrollY - image2Rect.top) * 0.2);
            parallaxImage2.style.transform = `translateY(${offset2}px)`;
        } else {
            parallaxImage2.style.transform = 'translateY(0)';
        }
    }

    window.addEventListener('scroll', handleParallax);
    handleParallax(); // Initial call
});
